import { TbCalendarUser, TbListDetails, TbPhone, TbScript } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

/** Sales pages shown as top-level items next to Home (no Sales parent toggle). */
export const salesRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.CALLS,
        meta: {
            label: "calls",
            order: 2,
            icon: TbPhone,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_READ_CALLS],
        },
    },
    {
        to: APP_ROUTES_TO.LISTS,
        meta: {
            label: "lists",
            order: 3,
            icon: TbListDetails,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_SETTING_LISTS],
        },
    },
    {
        to: APP_ROUTES_TO.APPOINTMENTS,
        meta: {
            label: "appointments",
            order: 4,
            icon: TbCalendarUser,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_CALENDAR_READ],
        },
    },
    {
        to: APP_ROUTES_TO.PRP_SCRIPT,
        meta: {
            label: "scripts",
            order: 5,
            icon: TbScript,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_SCRIPTS_READ],
        },
    },
];
